import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="projects--form"
export default class extends Controller {
  addressChanged(event) {
    document.getElementById('project_title').value = event.target.value
  }
}
